import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import Moment from 'react-moment';
import Barcode from '../comum/Barcode';

export class NotaFiscalCteOs extends Component {

    exibeCabecalho() {
        return (
            <div className='grid-cteos-container'>
                <div className='div-titulo'>DECLARO QUE RECEBI OS SERVIÇOS DESTE CONHECIMENTO EM PERFEITO ESTADO PELO QUE DOU POR CUMPRIDO O PRESENTE CONTRATO DE TRANSPORTE</div>
                <div className='div-espaco'></div>
                <div className='div-nome'><span className='nome'>NOME:</span></div>
                <div className='div-rg'><span className='rg'>RG:</span></div>
                <div className='div-assinatura'><span className='assinaturaCarimbo'>ASSINATURA/CARIMBO</span></div>
                <div className='div-terminio-prestacao'><span className='terminioPrestacao'>TÉRMINO DA PRESTAÇÃO - DATA/ HORA</span></div>
                <div className='div-inicio-prestacao'><span className='inicioPrestacao'>INICIO DA PRESTAÇÃO - DATA/HORA</span></div>
                <div className='div-cteos'>
                    <div className='subtitulo'>CT-e OS</div>
                    <div><span className='numero'>N°:</span><span className='numeroValor'>{this.props.emissaoCteOs.numero}</span></div>
                    <div><span className='serie'>Série:</span><span className='serieValor'>{this.props.emissaoCteOs.serie}</span></div>
                </div>
            </div>
        )
    }

    exibeNotaFiscal() {
        return (
            <>
                <hr style={{ borderTop: '2px dashed' }} />
                <div>
                    {this.exibeInicioNotaFiscalParte1()}
                    {this.exibeInicioNotaFiscalParte2()}
                    {this.exibeInformacoesPrestacaoServico()}
                    {this.exibeComponentesValorPrestacaoServico()}
                    {this.exibeInformacoesRelativasImposto()}
                    {this.exibeObservacao()}
                    {this.exibeInformacoesEspecificaDoModalRodoviario()}
                    {this.exibeSeguroVida()}
                </div>
            </>
        )
    }

    exibeBarcode(chaveCte) {
        return (
            <React.Fragment>
                <Barcode value={chaveCte} format="EAN13" />
            </React.Fragment>
        )
    }

    exibeQrCode(chaveCte) {
        return (
            <QRCode style={{
                width: 160,
                height: 160
            }}
                value={chaveCte} />
        )
    }

    exibeInicioNotaFiscalParte1() {
        return (
            <div className='grid-cteos-container-parte-1'>
                <div className='div-espaco-empresa'></div>
                <div className='div-empresa'>
                    <div className='titulo'>{this.props.emissaoCteOs.empresa.nomeFantasia}</div>
                    {this.props.emissaoCteOs.empresa.enderecoEmpresaDto && this.props.emissaoCteOs.empresa.enderecoEmpresaDto.length > 0 ? <div>
                        <div className='endereco'>
                            {this.props.emissaoCteOs.empresa.enderecoEmpresaDto[0].logradouro} {this.props.emissaoCteOs.empresa.enderecoEmpresaDto[0].complemento}
                        </div>
                        <div className='cidade'>{this.props.emissaoCteOs.empresa.enderecoEmpresaDto[0].bairro}, {this.props.emissaoCteOs.empresa.enderecoEmpresaDto[0].nomeCidade} - {this.props.emissaoCteOs.empresa.enderecoEmpresaDto[0].uf ? this.props.emissaoCteOs.empresa.enderecoEmpresaDto[0].uf.chave : ''}</div>
                        <div className='cep'>CEP: {this.props.emissaoCteOs.empresa.enderecoEmpresaDto[0].cep} Fone: </div>
                        <div className='cnpj'>CNPJ: {this.props.emissaoCteOs.empresa.cnpj}</div>
                        <div className='inscricaoEstadual'>Inscrição Estadual: {this.props.emissaoCteOs.empresa.inscricaoEstadual}</div>
                    </div> : <div>
                        <div className='endereco'>

                        </div>
                        <div className='cidade'></div>
                        <div className='cep'>CEP:  Fone: </div>
                        <div className='cnpj'>CNPJ: {this.props.emissaoCteOs.empresa.cnpj}</div>
                        <div className='inscricaoEstadual'>Inscrição Estadual: {this.props.emissaoCteOs.empresa.inscricaoEstadual}</div>
                    </div>}
                </div>
                <div className='div-dacteos'>
                    <div className='titulo'>DACTE OS</div>
                    <div className='subtitulo'>Documento Auxiliar do Conhecimento de Transporte Eletrônico para Outros Serviços</div>
                </div>
                <div className='div-dacteos-codigo-barra'>
                    <div className='campos'>
                        <div className='modelo'><span>MODELO</span> <br />
                            <span>{this.props.emissaoCteOs.modelo}</span>
                        </div>
                        <div className='serie'><span>SÉRIE</span> <br />
                            <span>{this.props.emissaoCteOs.serie}</span>
                        </div>
                        <div className='numero'><span>NÚMERO</span> <br />
                            <span>{this.props.emissaoCteOs.numero}</span>
                        </div>
                        <div className='folha'><span>FOLHA</span> <br />
                            <span>1/1</span>
                        </div>
                        <div><span>DATA E HORA EMISSÃO</span>  <br />
                            <span><Moment format="DD/MM/YYYY HH:mm">{this.props.emissaoCteOs.dataEmissao}</Moment></span>
                        </div>
                    </div>
                    <div className='dacte-os-codigo'>
                        {this.props.emissaoCteOs.ultimoHistoricoEmissaoCteOs.chaveCte ? this.exibeBarcode(this.props.emissaoCteOs.ultimoHistoricoEmissaoCteOs.chaveCte) : ''}
                    </div>
                    <div className='chaveacesso'><span>Chave de Acesso</span>
                        <p>{this.props.emissaoCteOs.ultimoHistoricoEmissaoCteOs.chaveCte ? this.props.emissaoCteOs.ultimoHistoricoEmissaoCteOs.chaveCte : ''}</p>
                    </div>
                    <div className='linkconsulta'>
                        Consulta de autenticidade no portal nacional do CT-e, no site da Sefaz Autorizadora, ou em http://www.cte.fazenda.gov.br/portal
                    </div>
                </div>
                <div className='div-modal'>
                    <div className='subtitulo'>MODAL</div>
                    <div className='titulo'>RODOVIÁRIO</div>
                </div>
                <div className='div-modal-qrcode'>
                    <p>{this.props.emissaoCteOs.ultimoHistoricoEmissaoCteOs.chaveCte ? this.exibeQrCode(this.props.emissaoCteOs.urlQRCode) : ''}</p>
                </div>
                <div className='div-tipocte'>
                    <span className='label'>TIPO DO CTE</span>
                    <p>CT-e Normal</p>
                </div>
                <div className='div-tiposervico'>
                    <span className='label'>TIPO DO SERVIÇO</span>
                    <p>{this.props.emissaoCteOs.tipoServico.valor.replace(/\d/g, '')}</p>
                </div>
            </div>
        )
    }

    exibeInicioNotaFiscalParte2() {
        return (
            <div className='grid-cteos-container-parte-2'>
                <div className='div-cfop-natureza-operacao'>
                    <span>CFOP - NATUREZA DA OPERAÇÃO</span>
                    <div>{this.props.emissaoCteOs.naturezaOperacao}</div>
                </div>
                <div className='div-protocolo-autorizacao-uso'>
                    <span>PROTOCOLO DE AUTORIZAÇÃO DE USO</span>
                    <div></div>
                </div>

                <div className='div-inicio-prestacao'>
                    <span>INICIO DA PRESTAÇÃO</span>
                    <div>{this.props.emissaoCteOs.cidadeOrigem.nomeComUf}</div>
                </div>
                <div className='div-percurso-veiculo'>
                    <span>PERCURSO DO VEÍCULO</span>
                    <div>{this.props.emissaoCteOs.percursosCteOsDto}</div>
                </div>
                <div className='div-terminio-prestacao2'>
                    <span>TERMINO DA PRESTAÇÃO</span>
                    <div>{this.props.emissaoCteOs.cidadeDestino.nomeComUf}</div>
                </div>
                <div className='div-tomador'>
                    <div><span>TOMADOR SERVIÇO: &nbsp;&nbsp;
                            {this.props.emissaoCteOs.tomador.nomePessoa && <span>{this.props.emissaoCteOs.tomador.nomePessoa}</span>}
                            {this.props.emissaoCteOs.tomador.nomeFantasia && <span>{this.props.emissaoCteOs.tomador.nomeFantasia}</span>}
                        </span>
                        <span>MUNICÍPIO/UF: &nbsp;&nbsp;
                            <span>{`${this.props.emissaoCteOs.tomador.endereco.nomeCidade}-${this.props.emissaoCteOs.tomador.endereco.uf}`}</span>
                        </span> <span>PAÍS: BR</span></div>
                    <div><span>ENDEREÇO: {`${this.props.emissaoCteOs.tomador.endereco.logradouro} ${this.props.emissaoCteOs.tomador.endereco.bairro} ${this.props.emissaoCteOs.tomador.endereco.complemento}`}</span> <span>CEP: {this.props.emissaoCteOs.tomador.endereco.cep}</span></div>
                    <div><span>CPF/CNPJ: {`${this.props.emissaoCteOs.tomador.tipoTomador == 'PF' ? this.props.emissaoCteOs.tomador.cpf : this.props.emissaoCteOs.tomador.cnpj}`}</span> <span>INSC.EST.: {this.props.emissaoCteOs.tomador.inscricaoEstadual}</span><span>FONE:  </span> <span>EMAIL: </span></div>
                </div>
            </div>
        )
    }

    exibeInformacoesPrestacaoServico() {
        return (
            <>
                <div className='div-titulo-container-p-4'><span>INFORMAÇÕES DA PRESTAÇÃO DO SERVIÇO</span></div>
                <div className='grid-cteos-container-p-4'>
                    <div className='div-quantidade-container-p-4'><span>QUANTIDADE</span> <div>{this.props.emissaoCteOs.quantidadeCarga}</div></div>
                    <div className='div-declaracao-servico-prestado-container-p-4'><span>DESCRIÇÃO DO SERVIÇO PRESTADO</span>
                        <div>{this.props.emissaoCteOs.descricaoServico}</div>
                    </div>
                </div>
            </>
        )
    }

    exibeComponentesValorPrestacaoServico() {
        return (
            <>
                <div className='div-titulo-componente-container-p-5'>COMPONENTES DO VALOR DA PRESTAÇÃO DE SERVIÇO</div>
                <div className='grid-cteos-container-parte-5'>
                    <div className='div-componente-1-valor-container-p-5'>
                        <div>Nome</div>
                        <div>Valor</div>
                    </div>
                    <div className='div-componente-2-valor-container-p-5'>
                        <div>Nome</div>
                        <div>Valor</div>
                    </div>
                    <div className='div-componente-3-valor-container-p-5'>
                        <div>Nome</div>
                        <div>Valor</div>
                    </div>
                    <div className='div-componente-4-valor-container-p-5'>
                        <div>Nome</div>
                        <div>Valor</div>
                    </div>
                    <div className='div-valor-total-prestacao-servico-container-p-5'>
                        <div>VALOR TOTAL DA PRESTAÇÃO DO SERVIÇO</div>
                        <span>{this.props.emissaoCteOs.valorServico}</span>
                    </div>
                    <div className='div-valor-a-receber-container-p-5'>
                        <div>VALOR A RECEBER</div>
                        <span>0,00</span>
                    </div>
                </div>
            </>
        )
    }

    exibeInformacoesRelativasImposto() {
        return (
            <>
                <div className='div-impostos-titulo'>INFORMAÇÕES RELATIVAS AO IMPOSTO</div>
                <div className='grid-cteos-container-parte-6'>
                    <div className='div-classificacao-tributaria-titulo'>
                        <div>CLASSIFICAÇÃO TRIBUTÁRIA DO SERVIÇO</div>
                        <span>ICMS Simples Nacional</span>
                    </div>
                    <div className='div-classificacao-tributaria-base-caluclo'>
                        <div>BASE DE CÁLCULO</div>
                        <span>{this.props.emissaoCteOs.valorServico}</span>
                    </div>
                    <div className='div-classificacao-tributaria-aliq-icms'>
                        <div>ALIQ. ICMS (%)</div>
                        <span>{this.props.emissaoCteOs.aliquotaIcms}</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-icms'>
                        <div>VALOR ICMS</div>
                        <span>{this.props.emissaoCteOs.valorIcms}</span>
                    </div>
                    <div className='div-classificacao-tributaria-red-bc'>
                        <div>% RED.BC.</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-st'>
                        <div>VALOR ST</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-inss'>
                        <div>VALOR INSS</div>
                        <span>{this.props.emissaoCteOs.valorInss}</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-pis'>
                        <div>VALOR PIS</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-cofins'>
                        <div>VALOR COFINS</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-ir'>
                        <div>VALOR IR</div>
                        <span>0,00</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-csll'>
                        <div>VALOR CSLL</div>
                        <span>0,00</span>
                    </div>
                </div>
                <div className='grid-cteos-container-parte-6-ibscbs'>
                    <div className='div-classificacao-tributaria-aliq-ibsuf'>
                        <div>ALÍQ IBS-UF</div>
                        <span>{this.props.emissaoCteOs.aliquotaIBSUF}</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-ibsuf'>
                        <div>VALOR IBS-UF</div>
                        <span>{this.props.emissaoCteOs.valorIBSUF}</span>
                    </div>
                    <div className='div-classificacao-tributaria-aliq-ibsmun'>
                        <div>ALÍQ IBS-MUN</div>
                        <span>{this.props.emissaoCteOs.aliquotaIBSMun}</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-ibsmun'>
                        <div>VALOR IBS-MUN</div>
                        <span>{this.props.emissaoCteOs.valorIBSMun}</span>
                    </div>
                    <div className='div-classificacao-tributaria-aliq-cbs'>
                        <div>ALÍQ CBS</div>
                        <span>{this.props.emissaoCteOs.aliquotaCBS}</span>
                    </div>
                    <div className='div-classificacao-tributaria-valor-cbs'>
                        <div>VALOR CBS</div>
                        <span>{this.props.emissaoCteOs.valorCBS}</span>
                    </div>
                </div>
            </>
        )
    }

    exibeObservacao() {
        return (
            <div className='grid-cteos-container-parte-7'>
                <div className='titulo'>OBSERVAÇÕES</div>
                <div className='textarea-observacao'></div>
            </div>
        )
    }

    exibeInformacoesEspecificaDoModalRodoviario() {
        return (
            <>
                <div className='div-titulo-modal-rodoviario-container-p-8'>
                    INFORMAÇÕES ESPECÍFICAS DO MODAL RODOVIÁRIO
                </div>
                <div className='grid-cteos-container-parte-8'>
                    <div className='div-termo-autorizacao-fretamento-container-p-8'>
                        <div>TERMO DE AUTORIZAÇÃO DE FRETAMENTO</div>
                        <span>{this.props.emissaoCteOs.termoAutorizacaoFretamento}</span>
                    </div>
                    <div className='div-numero-registro-estadual-container-p-8'>
                        <div>Nº DO REGISTRO ESTADUAL</div>
                        <span></span>
                    </div>
                    <div className='div-placa-veiculo-container-p-8'>
                        <div>PLACA DO VEÍCULO</div>
                        <span>{this.props.emissaoCteOs.veiculo.placa}</span>
                    </div>
                    <div className='div-renavam-container-p-8'>
                        <div>RENAVAM DO VEÍCULO</div>
                        <span>{this.props.emissaoCteOs.veiculo.renavam}</span>
                    </div>
                    <div className='div-licenciamneto-veiculo-container-p-8'>
                        <div>UF DE LICENCIAMENTO DO VEÍCULO</div>
                        <span></span>
                    </div>
                    <div className='div-cnpj-cpf-container-p-8'>
                        <div>CNPJ/CPF PROPRIETÁRIO</div>
                        <span></span>
                    </div>
                    <div className='div-tipo-fretamento-container-p-8'>
                        <div>TIPO FRETAMENTO</div>
                        <span>{this.props.emissaoCteOs.tipoFretamento.valor}</span>
                    </div>
                    <div className='div-dt-inicio-viagem-container-p-8'>
                        <div>DATA/HORA INÍCIO VIAGEM</div>
                        <span><Moment format="DD/MM/YYYY HH:mm">{this.props.emissaoCteOs.dataViagem}</Moment></span>
                    </div>
                </div>
            </>
        )
    }

    exibeSeguroVida() {
        return (
            <React.Fragment className="pagebreak">
                <div className='div-seguro-viagem-continar-p-9'>
                    SEGURO DA VIAGEM
                </div>
                <div className='grid-cteos-container-parte-9'>
                    <div className='div-responsavel-cteos-container-p-9'>
                        <div>RESPONSÁVEL</div>
                        <span>{this.props.emissaoCteOs.responsavelSeguro.valor}</span>
                    </div>
                    <div className='div-nome-seguradora-container-p-9'>
                        <div>NOME DA SEGURADORA</div>
                        <span>{this.props.emissaoCteOs.seguro.valor}</span>
                    </div>
                    <div className='div-numero-apolice-container-p-9'>
                        <div>NÚMERO DA APÓLICE</div>
                        <span></span>
                    </div>
                </div>
                <div className='div-area-emissor-e-fisco-container-9'>
                    <div className='div-uso-exclusivo-cteos-container-p-9'>
                        <div>USO EXCLUSIVO DO EMISSOR DO CT-e OS</div>
                        <div></div>
                    </div>
                    <div className='div-reservado-fisco-container-p-9'>
                        <div>RESERVADO AO FISCO</div>
                        <div></div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    render() {
        return (
            <div id="notaFiscalCteOs" className="grid invoice">
                <>
                    <div className="grid-body" id='nota-cteos' style={{ boxSizing: 'border-box' }}>
                        {this.exibeCabecalho()}
                        {this.exibeNotaFiscal()}
                    </div>
                </>
            </div>
        )
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
        emissaoCteOs: state.emissaoCteOsNotaFiscal

    });

export default withRouter(connect(mapStateToProps, {})(NotaFiscalCteOs));
